<template>
    <div class="container">
        <div class="topDiv">
            <div class="topDiv_item"  @click="selectTime(1)">
                <span class="topDiv_item_span">{{beginDate}}</span>
                <img  class="topDiv_item_icon" src="../../assets/images/icon_arrows_filter_normal.png"/>
            </div>
            <div class="topDiv_item" @click="selectTime(2)">
                <span class="topDiv_item_span">{{endDate}}</span>
                <img  class="topDiv_item_icon" src="../../assets/images/icon_arrows_filter_normal.png"/>
            </div>
        </div>
        <!-- :class="[$store.state.common.theme==3?'dataList_theme_3':'dataList'] " -->
        <div class="dataList">
            <Scroll
              :data="visitorList"
              :allLoaded="allLoaded"
              @pulldown="loadData"
              @loadUp="loadup"
              v-if="visitorList.length"
            >
            <div class="dataItem" v-for="(item,index) in visitorList" :key="index" @click="details(item.id)">
               <div class="dataItem_line">
                 <span class="line_title">来访访日期</span><span class="line_text">{{item.visitorDate}}</span>
               </div>
               <div class="dataItem_line">
                 <span class="line_title">访客姓名</span><span class="line_text">{{item.visitorUserName}}</span>
               </div>
               <div class="dataItem_line">
                 <span class="line_title">访客电话</span><span class="line_text">{{item.visitorMobile}}</span>
               </div>
               <div class="dataItem_line" v-if="item.visitorFloor">
                 <span class="line_title">来访地址</span><span class="line_text">{{item.visitorFloor}}</span>
               </div>
               <div class="dataItem_status" :class="{'status_active2':item.status==2,'status_active1':item.status==1,'status_active6':item.status==6||item.status==3}">{{item.status|statusFilters}}</div>
            </div>
            </Scroll>
          <nomessage v-if="!visitorList.length"></nomessage>
        </div>

        <!-- -->
        <yd-datetime
            style="display:none;"
            ref="datetime_date"
            @input="dateChange"
            type="date"
            v-model="date"
            startDate="2020-01-01"
            endDate="2030-12-31" 
          
        ></yd-datetime>
    </div>
</template> 

<script>
import nomessage from '../../components/nomessage';
import { getVisitorListByMarketId } from '../../utils/api'
import Scroll from "../../components/scroll";
import util from "../../utils/util";
import { mapState } from 'vuex';


export default {
  name: "history",
  components: {
    Scroll,
    nomessage
  },
  data() {
    return {
        beginDate:'',
        endDate:'',
        dataType:"",
        date:"",
        activeIndex:0,
        pageNo:1,
        pageSize: 10,
        allLoaded: false, // 可以进行上拉
        loaded: false,
        mode:'0',//0拜访 1邀请
        visitorList:[]
    };
  },
  computed: {
    ...mapState({
      // openId: state => state.common.openId,
      userId: state => state.common.userId,
      marketInfo: state => state.common.marketInfo
    })
  },
  filters:{
    statusFilters(status){
      switch (status) {
         case 1:
           return '已发预约';
         case 2:
           return '预约成功';
         case 3:
         case 6:
           return '审批未通过';
         case 4:
           return '已取消';
         case 5:
           return '拜访结束';
       }
    }
  },
  created () {
    this.endDate = util.formatTime(new Date(), 4);
    this.date = util.formatTime(new Date(), 4);
    var srt = this.endDate.split('-');
    this.beginDate = parseInt(srt[0])-1+'-'+srt[1]+'-'+srt[2];
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    selectTime(type){
        this.dataType = type;
        if(type == 1){
            this.date = this.beginDate;
        } else if(type == 2){
            this.date = this.endDate;
        }
        this.$refs.datetime_date.open();
    },
    dateChange(val){
        console.log(JSON.stringify(val))
        if(this.dataType == 1){
            this.beginDate = val;
        } else if(this.dataType == 2){
            this.endDate = val;
        }

        this.loadData()

    },
    // 上拉加载
    loadup() {
      if (this.allLoaded) {
        return;
      }
      this.pageNo++;
      this.fetchData();
    },
    // 下拉刷新
    loadData() {
      this.pageNo = 1;
      util.showLoading()
      this.fetchData();
    },

    fetchData(){
      getVisitorListByMarketId({
        "userId": this.userId,
        "marketId": this.marketInfo.id,
        "type": this.activeIndex.toString(),
        "pageNo": this.pageNo,
        startDay:this.beginDate,
        endDay:this.endDate,
        // "mode":this.mode,
        recordType:'2',
        "pageSize": 10
      }).then(res => {
        console.log('res')
         console.log(res)
         util.hideLoading();
         let data = res.body.visitorList;
         //res.body.visitorList;
         if (data.length !== 10) {
           this.allLoaded = true; // 若数据已全部获取完毕
         }
         if (this.pageNo === 1) {
           this.visitorList = data;
         } else {
           this.visitorList = [...this.visitorList, ...data];
         }
      })
    },
    details(id){
      let mode = this.mode
      // this.$router.push(`/visitDetails?id=${id}&mode=${mode}`);
    },
    changeTab(index){
      this.activeIndex = index
      this.pageNo = 1;
      this.fetchData()
    }
  }
};
</script>

<!-- @import "../../assets/css/common.less"; -->
<style lang="less" scoped>

.container {
  background: rgba(238, 238, 238, 1);
  height: 100vh;
  //
  
}
.topDiv{
    width: 100%;
    height: 88px;
    flex-direction: row;
    background:rgba(238, 238, 238, 1);
    display: flex;
}
.topDiv_item{
    height: 88px;
    width: 50%;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    display: flex;
}
.topDiv_item_span{
    height:40px;
    font-size:28px;
    font-weight:400;
    color:rgba(51,51,51,1);
    line-height:40px;
}

.topDiv_item_icon{
    width: 24px;
    height: 24px;
    margin-left: 16px;
    display: flex;
}
.dataList{
    flex:1;
    height:calc(100vh - 128px);
}
.dataItem{
    width:710px;
    background:rgba(255,255,255,1);
    border-radius:8px;
    margin:20px 20px 0;
    padding:28px;
    box-sizing: border-box;
    position: relative;
    margin-bottom: 20px;
}
.dataItem_status{
    font-size:24px;
    font-family:PingFangSC;
    font-weight:400;
    line-height:32px;
    position: absolute;
    top: 28px;
    right: 28px;
    color:rgba(153, 153, 153,1);
  }
  .status_active2{
    color:rgba(22,188,132,1);
  }
  .status_active1{
    color:rgba(255, 173, 93, 1);
  }
  .status_active6{
    color:rgba(252, 63, 86, 1);
  }
  .dataItem_line{
    height: 34px;
    margin-bottom:8px;
    display:flex;
    .line_title,.line_text{
      font-size:24px;
      font-family:PingFangSC;
      font-weight:400;
      color:rgba(153,153,153,1);
      line-height:34px;
      display: inline-block;
      margin-right: 28px;
      white-space: nowrap;
    }
    .line_text{
      color:rgba(51,51,51,1);
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

</style>